export enum ChartType {
    PASSENGER_COUNTERS_BAR = 'showAsBarChart',
    PASSENGER_COUNTERS_PIE = 'showAsPieChart'
}
